<template>
	<div class="content">
		<div class="menu-list">
			<van-button type="primary" size="small" @click="showAddTypeDialog()">添加菜品类型</van-button>
			<van-button type="primary" size="small" @click="showAddMenuDialog()">添加菜品</van-button>
			<van-button type="danger" size="small" @click="showDeleteButton = !showDeleteButton">{{
				showDeleteButton ? '关闭删除模式' : '删除模式' }}</van-button>
		</div>
		<div class="menu-browse" v-if="!showMenu">
			<div class="browse-card browse-card-types">
				<div class="browse-section-title">菜品分类</div>
				<div class="menu-types">
					<span class="type-chip" :class="{ 'selected': selectedType === null }" @click="switchMenuType(null)">全部</span>
					<span class="type-chip" :class="{ 'selected': selectedType === type }" v-for="(type, index) in menuTypes" :key="index">
						<span @click="switchMenuType(type)">{{ type }}</span>
						<van-icon class="delete-icon" name="clear" v-show="showDeleteButton" @click.stop="deleteMenuType(type)" />
					</span>
				</div>
			</div>
			<div class="browse-card browse-card-dishes">
				<div class="browse-section-title">
					<span>菜品列表</span>
					<span class="browse-count">共 {{ menuNameList.length }} 道</span>
				</div>
				<div v-if="menuNameList.length === 0" class="empty-dishes">暂无菜品</div>
				<div v-else class="menu-name">
					<div class="dish-chip" v-for="(menu, index) in menuNameList" :key="index">
						<span class="dish-chip-name" @click="getMenuDetail(menu.id)">{{ menu.name }}</span>
						<van-icon class="delete-icon" name="clear" v-show="showDeleteButton" @click.stop="deleteMenu(menu.id)" />
					</div>
				</div>
			</div>
		</div>
		<van-dialog v-model="showAddType" title="添加菜单类型" showCancelButton @confirm="addType">
			<van-field v-model="newType" label="菜单类型" :error-message="validateType" @input="inputType"
				placeholder="请输入类型名称" />
		</van-dialog>
		<van-dialog class="add-menu" v-model="showAddMenu" :title="isAdd ? '添加菜品' : '编辑菜品'" showCancelButton
			@confirm="modifyMenu" :beforeClose="beforeClose" @cancel="closeDialog">
			<van-field label-width="32" v-model="menuName" label="名字" />
			<van-field label-width="32" readonly clickable name="picker" :value="selectedMenuType" label="类型"
				placeholder="选择类型" @click="showMenuTypePicker = true" />
			<van-popup v-model="showMenuTypePicker" position="bottom">
				<van-picker show-toolbar :columns="menuTypes" @confirm="onSelectMenuType"
					@cancel="showMenuTypePicker = false" />
			</van-popup>
			<div class="custom-field">
				<span class="custom-label">归属</span>
				<span :class="{ 'selected-belong': belongMeals.includes('breakfast') }"
					@click="setBelong('breakfast')">早餐</span>
				<span :class="{ 'selected-belong': belongMeals.includes('lunch') }"
					@click="setBelong('lunch')">午饭</span>
				<span :class="{ 'selected-belong': belongMeals.includes('dinner') }"
					@click="setBelong('dinner')">晚餐</span>
			</div>
			<div class="custom-field">
				<span class="custom-label">归属</span>
				<van-radio-group v-model="detailType" direction="horizontal">
					<van-radio icon-size="16px" name="text">文字</van-radio>
					<van-radio icon-size="16px" name="img">图片</van-radio>
				</van-radio-group>
			</div>
			<van-field v-if="detailType === 'text'" v-model="rawMaterials" label="食材" label-width="32" rows="1" autosize
				type="textarea" @input="inputType" placeholder="请输入所需食材" />
			<div class="step-box" v-if="detailType === 'text'">
				<div class="step-box-title">步骤</div>
				<div class="step" v-for="(step, index) in steps" :key="step.id">
					<div class="big-step">
						<span class="mt6">{{ index + 1 }}.</span>
						<van-field v-model="step.content" rows="1" autosize type="textarea" @input="inputType" />
						<van-icon class="mt6" name="clear" @click="deleteStep(step.id)" />
					</div>
					<div class="sub-step" v-for="subStep in step.child" :key="subStep.id">
						<div class="small-step">
							<van-icon name="stop" />
							<van-field v-model="subStep.content" rows="1" autosize type="textarea" @input="inputType" />
							<van-icon name="clear" @click="deleteStep(subStep.id)" />
						</div>
					</div>
					<!-- <div class="add-new-step sub-step" @click="addStep(step.id)"><van-icon name="plus" />小步骤</div> -->
				</div>
				<div class="add-new-step" @click="addStep()"><van-icon name="plus" />大步骤</div>
			</div>
			<div>

			</div>
			<van-uploader v-if="detailType === 'img'" v-model="fileList" :after-read="afterRead" />
		</van-dialog>
		<div class="menu-detail" v-if="showMenu && menuDetail">
			<div class="menu-detail-scroll">
				<div class="detail-hero">
					<div class="detail-hero-emoji">🍽️</div>
					<div class="menu-detail-title">{{ menuDetail.name }}</div>
					<div class="detail-meta" v-if="menuDetail.type || (menuDetail.belongMeals && menuDetail.belongMeals.length)">
						<span v-if="menuDetail.type" class="detail-tag">{{ menuDetail.type }}</span>
						<span
							v-for="meal in menuDetail.belongMeals"
							:key="meal"
							class="detail-tag detail-tag-meal"
						>{{ belongMealLabel(meal) }}</span>
					</div>
				</div>

				<div v-if="detailType === 'text'" class="detail-card">
					<div class="detail-section-title">原料</div>
					<div class="detail-materials">{{ menuDetail.rawMaterials }}</div>
				</div>

				<div v-if="detailType === 'text'" class="detail-card detail-card-steps">
					<div class="detail-section-title">步骤</div>
					<div class="step-detail-card" v-for="(des, index) in menuDetail.content" :key="des.id">
						<div class="step-number">{{ index + 1 }}</div>
						<div class="step-body">
							<div class="step-main-text">{{ des.content }}</div>
							<div class="step-sub-item" v-for="subDes in des.child" :key="subDes.id">
								<span class="step-sub-dot"></span>
								<span>{{ subDes.content }}</span>
							</div>
						</div>
					</div>
				</div>

				<div class="preview-img-list" v-if="detailType === 'img'">
					<van-image
						class="preview-img"
						width="100%"
						v-for="(file, index) in menuDetail.files"
						:key="file"
						:src="file"
						@click="previewImg(index)"
					/>
				</div>
			</div>

			<div class="menu-detail-actions">
				<van-button class="detail-back-btn" plain @click="showMenu = false">返回列表</van-button>
				<van-button class="detail-edit-btn" type="primary" @click="showMenu = editMenu(menuDetail)">编辑</van-button>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getMenuTypeList,
	getMenuNameList,
	getMenuNameListByType,
	getMenuDetail,
	deleteMenuType,
	deleteMenu,
	modifyMenu,
	uploadFile,
	addMenuType
} from '../util/api'
import { Dialog, Notify, ImagePreview } from 'vant';
import { registerBackHandler } from '../util/backNavigation';
export default {
	name: 'FoodMenu',
	data() {
		return {
			showAddType: false,
			showAddMenu: false,
			showMenu: false,
			showMenuTypePicker: false,
			newType: '',
			rawMaterials: '',
			menuName: '',
			validateType: null,
			validateModifyData: false,
			selectedMenuType: null,
			selectedType: null,
			menuTypes: [],
			menuNameList: [],
			steps: [],
			belongMeals: [],
			menuDetail: null,
			scrollListDom: null,
			showDeleteButton: false,
			isAdd: true,   // true: 添加  false:编辑
			detailType: 'text',
			fileList: []
		}
	},
	methods: {
		previewImg(startPosition) {
			ImagePreview({
				images: this.menuDetail.files,
				startPosition,
			});
		},
		afterRead(file) {
			file.status = 'uploading';
			file.message = '上传中...';
			const formData = new FormData();
			formData.append('file', file.file);
			uploadFile(formData).then((res) => {
				if (res?.data?.success) {
					file.status = 'done';
					file.message = '上传成功';
					file.url = `https://api.starl.site${res.data.filePath}`
				} else {
					file.status = 'failed';
					file.message = '上传失败';
				}
			})
		},
		onSelectMenuType(value) {
			this.selectedMenuType = value
			this.showMenuTypePicker = false;
		},
		showAddTypeDialog() {
			this.showAddType = true
		},
		showAddMenuDialog() {
			this.isAdd = true;
			this.showAddMenu = true
			this.$nextTick(() => {
				this.addScrollListener()
			})
		},
		addType() {
			if (!this.newType) {
				return
			}
			addMenuType({
				name: this.newType
			}).then(() => {
				this.getMenuTypes();
				this.clearData()
			})
		},
		editMenu(menuDetail) {
			this.showMenu = false
			this.isAdd = false;
			this.$set(this, 'menuName', menuDetail.name)
			this.$set(this, 'selectedMenuType', menuDetail.type)
			this.$set(this, 'rawMaterials', menuDetail.rawMaterials)
			this.$set(this, 'steps', menuDetail.content)
			this.$set(this, 'belongMeals', menuDetail.belongMeals)
			this.$set(this, 'detailType', menuDetail.detailType || 'text')
			this.$set(this, 'fileList', [...menuDetail.files.map((file) => ({url: file}))])
			this.showAddMenu = true
			this.$nextTick(() => {
				this.addScrollListener()
			})
		},
		closeDialog() {
			this.clearData()
		},
		beforeClose(action, done) {
			if (action === 'confirm' && !this.validateModifyData) {
				done(false)
			}
			done()
		},
		modifyMenu() {
			const finalSteps = this.filterEmptySteps()
			this.validateModifyData = false;
			const fileList = this.fileList.filter((file) => file?.url).map((file) => file.url)
			if (!this.menuName) {
				Notify({ type: 'danger', message: '请菜品名称' });
				return
			}
			if (!this.selectedMenuType) {
				Notify({ type: 'danger', message: '请选择类型' });
				return
			}
			if (!this.belongMeals || this.belongMeals.length === 0) {
				Notify({ type: 'danger', message: '请选择归属' });
				return
			}
			if (this.detailType === 'text' && !this.rawMaterials) {
				Notify({ type: 'danger', message: '请输入所需材料' });
				return
			}
			if (this.detailType === 'text' && finalSteps.length === 0) {
				Notify({ type: 'danger', message: '请输入步骤' });
				return
			}
			if (this.detailType === 'img' && fileList.length === 0) {
				Notify({ type: 'danger', message: '请选择图片' });
				return
			}
			this.validateModifyData = true;
			modifyMenu({
				id: this.isAdd ? null : this.menuDetail.id,
				name: this.menuName,
				type: this.selectedMenuType,
				rawMaterials: this.rawMaterials,
				detailType: this.detailType,
				content: finalSteps,
				files: fileList,
				belongMeals: this.belongMeals
			}).then(() => {
				this.clearData()
				this.removeScrollListener();
				this.getMenuNameList()
			})
		},
		getMenuTypes() {
			getMenuTypeList().then((res) => {
				this.$set(this, "menuTypes", res.data.map((type) => type.name))
			})
		},
		getMenuNameList() {
			if (this.selectedType) {
				getMenuNameListByType({
					type: this.selectedType
				}).then((res) => {
					this.$set(this, "menuNameList", res.data)
				})
			} else {
				getMenuNameList().then((res) => {
					this.$set(this, "menuNameList", res.data)
				})
			}
		},
		getMenuDetail(id) {
			getMenuDetail({
				id: id
			}).then((res) => {
				this.$set(this, "menuDetail", res.data.map((menu) => ({
					...menu,
					content: JSON.parse(menu.content),
					belongMeals: menu.belongMeals ? JSON.parse(menu.belongMeals) : [],
					files: menu.files ? JSON.parse(menu.files) : []
				}))[0])
				this.detailType = this.menuDetail.detailType || 'text'
				this.$set(this, "showMenu", true)
			})
		},
		inputType(type) {
			this.validateType = type === 'asd' ? "类型已存在" : null
		},
		switchMenuType(type) {
			this.selectedType = type
			this.getMenuNameList()
		},
		deleteStep(id) {
			Dialog.confirm({
				message: '确认删除这一步吗'
			}).then(() => {
				this.$set(this, 'steps', this.deleteStepData(id));
			}).catch(() => {
			});
		},
		deleteStepData(id) {
			const newSteps = this.steps.map((step) => {
				return {
					...step,
					child: step.child.filter((subStep) => subStep.id !== id)
				}
			}).filter((step) => step.id !== id)
			return newSteps
		},
		deleteMenuType(name) {
			Dialog.confirm({
				message: '确认删除该类型吗'
			}).then(() => {
				deleteMenuType({
					name
				}).then(() => {
					this.getMenuTypes()
				})
			}).catch(() => {
			});
		},
		deleteMenu(id) {
			Dialog.confirm({
				message: '确认删除该菜品吗'
			}).then(() => {
				deleteMenu({
					id
				}).then(() => {
					this.getMenuNameList()
				})
			}).catch(() => {
			});
		},
		filterEmptySteps() {
			const newSteps = this.steps.map((step) => {
				return {
					...step,
					child: step.child.filter((subStep) => subStep.content)
				}
			}).filter((step) => step.content)
			return newSteps
		},
		addStep(subId) {
			let newSteps
			if (subId) {
				newSteps = this.steps.map((step) => {
					if (step.id === subId) {
						return {
							...step,
							child: [
								...step.child,
								{
									id: new Date().getTime(),
									content: '',
								}
							]
						}
					} else {
						return step
					}
				})
			} else {
				newSteps = [...this.steps, {
					id: new Date().getTime(),
					content: '',
					child: []
				}]
			}
			this.$set(this, 'steps', newSteps);
		},
		clearData() {
			this.menuName = null;
			this.newType = null;
			this.rawMaterials = null;
			this.validateType = null;
			this.selectedMenuType = null;
			this.menuDetail = null;
			this.detailType = 'text';
			this.steps = [];
			this.fileList = [];
			this.belongMeals = [];
		},
		addScrollListener() {
			this.scrollListDom = document.querySelector('.step-box')
			if (this.scrollListDom) {
				this.scrollListDom.addEventListener('touchmove', e => e.stopPropagation(), false)
			}

		},
		removeScrollListener() {
			if (this.scrollListDom) {
				this.scrollListDom.removeEventListener('touchmove', e => e.stopPropagation(), false)
				this.scrollListDom = null
			}
		},
		setBelong(belongMeal) {
			let tempBelongMeals = []
			if (this.belongMeals.includes(belongMeal)) {
				tempBelongMeals = this.belongMeals.filter((bm) => bm !== belongMeal)
			} else {
				tempBelongMeals = [...this.belongMeals, belongMeal]
			}
			this.$set(this, "belongMeals", tempBelongMeals)
		},
		belongMealLabel(meal) {
			const map = {
				breakfast: '早餐',
				lunch: '午饭',
				dinner: '晚餐'
			}
			return map[meal] || meal
		}
	},
	mounted() {
		this.getMenuTypes();
		this.getMenuNameList();
		this.unregisterBackHandler = registerBackHandler(() => {
			if (this.showMenu) {
				this.showMenu = false
				return true
			}
			return false
		})
	},
	beforeDestroy() {
		if (this.unregisterBackHandler) {
			this.unregisterBackHandler()
		}
	}
}
</script>


<style scoped>
.content {
	/* Q版：柔和底色 + 更舒适的整体间距 */
	--q-bg0: #fff7fb;
	--q-bg1: #f2fbff;
	--q-card: rgba(255, 255, 255, 0.92);
	--q-text: #2f3440;
	--q-sub: #6b7280;
	--q-line: rgba(15, 23, 42, 0.08);
	--q-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);
	--q-shadow-sm: 0 6px 14px rgba(17, 24, 39, 0.08);
	--q-radius: 16px;
	--q-radius-sm: 12px;
	--q-primary: #34c3ff;
	--q-primary-2: #6ee7ff;
	--q-danger: #ff5f7a;
	--q-success: #2dd4bf;
	--q-warn: #ffb020;
	--q-chip: rgba(255, 255, 255, 0.92);

	height: 100%;
	min-height: 0;
	overflow: hidden;
	padding: 20px 16px 24px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	gap: 12px;
	color: var(--q-text);
	position: relative;
	font-family: "Comic Sans MS", "Microsoft YaHei UI", "PingFang SC", "Hiragino Sans GB", system-ui, -apple-system,
		BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
	background: radial-gradient(120% 90% at 20% 0%, var(--q-bg0) 0%, transparent 60%),
		radial-gradient(120% 90% at 90% 30%, var(--q-bg1) 0%, transparent 55%),
		#ffffff;
}

.content::before,
.content::after {
	content: "";
	position: fixed;
	z-index: -1;
	pointer-events: none;
	filter: blur(0px);
	opacity: 0.9;
}
.content::before {
	width: 220px;
	height: 220px;
	left: -80px;
	top: 120px;
	background: radial-gradient(circle at 30% 30%, rgba(255, 184, 220, 0.55), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(110, 231, 255, 0.45), transparent 62%);
	border-radius: 999px;
}
.content::after {
	width: 260px;
	height: 260px;
	right: -120px;
	bottom: 60px;
	background: radial-gradient(circle at 40% 30%, rgba(196, 255, 214, 0.5), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(255, 224, 170, 0.45), transparent 62%);
	border-radius: 999px;
}

/* 不要对 `.content > *` 统一加 position/z-index，会破坏 Vant Dialog/Popup 的 fixed 布局 */

.mt6 {
	margin-top: 6px;
}



.menu-list {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	justify-content: space-between;
	flex-shrink: 0;
	padding: 10px 12px;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
	backdrop-filter: blur(8px);
}

.menu-list /deep/ .van-button {
	transition: transform 120ms ease, box-shadow 120ms ease, filter 120ms ease;
}
.menu-list /deep/ .van-button:active {
	transform: translateY(1px) scale(0.98);
	filter: saturate(1.05);
}

.step-box {
	display: flex;
	flex-direction: column;
	font-size: 12px;
	padding: 0 16px 16px;
	margin-top: 10px;
	gap: 18px;
	max-height: 280px;
	overflow: auto;
}

.step-box /deep/ textarea {
	font-size: 12px !important;
}

.step {
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.step .van-cell {
	padding: 0;
	margin-left: 2px;
}

.step-box-title {
	font-size: 14px;
	font-weight: 700;
}

.add-new-step {
	color: var(--q-sub);
	padding: 8px 10px;
	border: 1px dashed var(--q-line);
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.7);
}

.sub-step {
	margin-left: 12px;
}

.big-step,
.small-step {
	display: flex;
}

.menu-types,
.menu-name {
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
}

.menu-browse {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.browse-card {
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
	padding: 12px;
}

.browse-card-types {
	flex-shrink: 0;
}

.browse-card-dishes {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
}

.browse-section-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 13px;
	font-weight: 700;
	color: var(--q-text);
	margin-bottom: 10px;
}

.browse-count {
	font-size: 12px;
	font-weight: 500;
	color: var(--q-sub);
}

.menu-types {
	flex-wrap: nowrap;
	overflow-x: auto;
	padding-bottom: 4px;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: none;
}

.menu-types::-webkit-scrollbar {
	display: none;
}

.type-chip {
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-size: 13px;
	padding: 7px 14px;
	border: 1px solid var(--q-line);
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.88);
	box-shadow: 0 2px 8px rgba(17, 24, 39, 0.05);
	transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease, background 120ms ease;
	user-select: none;
	white-space: nowrap;
}

.type-chip:active {
	transform: scale(0.98);
}

.type-chip.selected {
	border-color: rgba(52, 195, 255, 0.9);
	color: #0284c7;
	box-shadow: 0 4px 12px rgba(52, 195, 255, 0.16);
	background: linear-gradient(180deg, rgba(52, 195, 255, 0.14) 0%, rgba(110, 231, 255, 0.08) 100%);
}

.menu-name {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px;
	align-content: start;
	padding-right: 2px;
}

.dish-chip {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 6px;
	min-height: 44px;
	padding: 10px 12px;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius-sm);
	background: rgba(255, 255, 255, 0.9);
	box-shadow: 0 2px 8px rgba(17, 24, 39, 0.04);
	transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease;
}

.dish-chip:active {
	transform: scale(0.985);
	border-color: rgba(52, 195, 255, 0.35);
	box-shadow: 0 4px 12px rgba(52, 195, 255, 0.1);
}

.dish-chip-name {
	flex: 1;
	min-width: 0;
	font-size: 13px;
	line-height: 1.4;
	word-break: break-all;
}

.delete-icon {
	flex-shrink: 0;
	color: var(--q-danger);
	font-size: 16px;
}

.empty-dishes {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--q-sub);
	font-size: 13px;
}

.menu-detail {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: calc(100% - 64px);
	z-index: 10;
	background: radial-gradient(120% 90% at 20% 0%, var(--q-bg0) 0%, transparent 60%),
		radial-gradient(120% 90% at 90% 30%, var(--q-bg1) 0%, transparent 55%),
		#ffffff;
	padding: 16px 16px 12px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	gap: 12px;
	font-size: 14px;
}

.menu-detail-scroll {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding-bottom: 4px;
}

.detail-hero {
	padding: 20px 16px;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
	text-align: center;
}

.detail-hero-emoji {
	font-size: 32px;
	line-height: 1;
	margin-bottom: 8px;
}

.menu-detail-title {
	font-size: 20px;
	font-weight: 800;
	letter-spacing: 0.2px;
	color: var(--q-text);
	line-height: 1.3;
}

.detail-meta {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 8px;
	margin-top: 12px;
}

.detail-tag {
	font-size: 12px;
	padding: 4px 10px;
	border-radius: 999px;
	border: 1px solid rgba(52, 195, 255, 0.35);
	background: rgba(52, 195, 255, 0.1);
	color: #0284c7;
}

.detail-tag-meal {
	border-color: rgba(45, 212, 191, 0.4);
	background: rgba(45, 212, 191, 0.12);
	color: #0d9488;
}

.detail-card {
	padding: 14px 16px;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
}

.detail-section-title {
	font-size: 14px;
	font-weight: 700;
	color: var(--q-text);
	margin-bottom: 10px;
	padding-left: 10px;
	border-left: 3px solid var(--q-primary);
	line-height: 1.2;
}

.detail-materials {
	font-size: 14px;
	line-height: 1.7;
	color: var(--q-text);
	white-space: pre-wrap;
	word-break: break-word;
}

.detail-card-steps {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.step-detail-card {
	display: flex;
	gap: 12px;
	padding: 12px;
	border-radius: var(--q-radius-sm);
	background: rgba(255, 255, 255, 0.88);
	border: 1px solid var(--q-line);
}

.step-number {
	flex-shrink: 0;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 13px;
	font-weight: 700;
	color: #fff;
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
	box-shadow: 0 4px 10px rgba(52, 195, 255, 0.22);
}

.step-body {
	flex: 1;
	min-width: 0;
}

.step-main-text {
	font-size: 14px;
	line-height: 1.65;
	color: var(--q-text);
	word-break: break-word;
}

.step-sub-item {
	display: flex;
	align-items: flex-start;
	gap: 8px;
	margin-top: 8px;
	padding-left: 4px;
	font-size: 13px;
	line-height: 1.6;
	color: var(--q-sub);
}

.step-sub-dot {
	flex-shrink: 0;
	width: 6px;
	height: 6px;
	margin-top: 7px;
	border-radius: 50%;
	background: var(--q-primary);
}

.menu-detail-actions {
	flex-shrink: 0;
	display: flex;
	gap: 10px;
	padding: 12px 2px 4px;
	margin-top: 4px;
	border-top: 1px solid var(--q-line);
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.96) 100%);
	backdrop-filter: blur(10px);
}

.menu-detail-actions /deep/ .van-button {
	flex: 1;
	height: 40px;
	line-height: 40px;
	border-radius: 12px !important;
	font-size: 14px;
	font-weight: 600;
	box-shadow: none !important;
}

.menu-detail-actions /deep/ .detail-back-btn {
	color: #64748b !important;
	background: rgba(255, 255, 255, 0.92) !important;
	border: 1px solid rgba(148, 163, 184, 0.35) !important;
}

.menu-detail-actions /deep/ .detail-back-btn:active {
	background: rgba(241, 245, 249, 0.95) !important;
}

.menu-detail-actions /deep/ .detail-edit-btn {
	border: none !important;
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%) !important;
	box-shadow: 0 4px 12px rgba(52, 195, 255, 0.2) !important;
}

.menu-detail-actions /deep/ .detail-edit-btn:active {
	opacity: 0.92;
	transform: translateY(1px);
}

.preview-img-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.preview-img {
	border-radius: var(--q-radius-sm);
	overflow: hidden;
	border: 1px solid var(--q-line);
	box-shadow: var(--q-shadow-sm);
}

.custom-field {
	display: flex;
	font-size: 12px;
	padding: 10px 16px;
}

.custom-field span:not(:first-child) {
	border: 1px solid var(--q-line);
	margin-right: 10px;
	padding: 6px 12px;
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.75);
}

.custom-field .selected-belong {
	border-color: rgba(45, 212, 191, 0.95) !important;
	box-shadow: 0 6px 14px rgba(45, 212, 191, 0.18);
	background: rgba(45, 212, 191, 0.12);
}

.custom-label {
	font-size: 14px;
	color: var(--q-sub);
	margin-right: 10px;
}

.van-uploader{
	padding: 10px 16px;
}

/* 适配 Vant 组件：让按钮更“糖果感” */
.content /deep/ .van-button--primary {
	border: none;
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
	box-shadow: 0 8px 18px rgba(52, 195, 255, 0.22);
	border-radius: 999px;
}
.content /deep/ .van-button--danger {
	border: none;
	background: linear-gradient(180deg, #ff6b84 0%, var(--q-danger) 100%);
	box-shadow: 0 8px 18px rgba(255, 95, 122, 0.22);
	border-radius: 999px;
}
.content /deep/ .van-button--plain.van-button--primary {
	border: 1px solid rgba(52, 195, 255, 0.55);
	background: rgba(255, 255, 255, 0.86);
	color: #0ea5e9;
	box-shadow: 0 6px 14px rgba(52, 195, 255, 0.12);
	border-radius: 999px;
}
.content /deep/ .van-button--plain.van-button--info {
	border: 1px solid rgba(148, 163, 184, 0.55);
	background: rgba(255, 255, 255, 0.86);
	color: #334155;
	box-shadow: 0 6px 14px rgba(17, 24, 39, 0.08);
	border-radius: 999px;
}
.content /deep/ .van-dialog {
	border-radius: 18px;
	overflow: hidden;
}
.content /deep/ .van-field__label {
	color: var(--q-sub);
}

/* 修复：对话框内容过高时可滚动（不改 dialog 布局） */
.add-menu /deep/ .van-dialog__content {
	max-height: 70vh;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	padding-bottom: 6px;
}
</style>
